import { render, staticRenderFns } from "./addReplenishment.vue?vue&type=template&id=9f364360&scoped=true&"
import script from "./addReplenishment.vue?vue&type=script&lang=js&"
export * from "./addReplenishment.vue?vue&type=script&lang=js&"
import style0 from "./addReplenishment.vue?vue&type=style&index=0&id=9f364360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f364360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f364360')) {
      api.createRecord('9f364360', component.options)
    } else {
      api.reload('9f364360', component.options)
    }
    module.hot.accept("./addReplenishment.vue?vue&type=template&id=9f364360&scoped=true&", function () {
      api.rerender('9f364360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/components/addReplenishment.vue"
export default component.exports